import React from "react";
import { Row, Col } from "antd";
import ButtonComponent from "../ButtonComponent";
import ContainerService from "../../../services/ContainerService/container.service";

interface MaerskActionsProps {
  selectedRowKeys: number[];
  onMaeskActionSuccess?: () => void;
  showQuoteBtn?: boolean;
  showUpdateStatus?: boolean;
  quoteSpan?: number;
  statusSpan?: number;
  quoteBtnText?:string;
  disabled?:boolean
}

const MaerskActions: React.FC<MaerskActionsProps> = ({
  selectedRowKeys,
  onMaeskActionSuccess,
  showQuoteBtn = true,
  showUpdateStatus = true,
  quoteSpan,
  statusSpan,
  quoteBtnText,
  disabled=false
}) => {
  const {
    sendMaerskQuote,
    updateMaerskStatus,
    maerskQuoteLoading,
    maerskStatusLoading,
  } = ContainerService();
  

  const handleSendQuote = async () => {
    const res = await sendMaerskQuote(selectedRowKeys);
    if (res) onMaeskActionSuccess?.();
  };

  const handleUpdateStatus = async () => {
    const res = await updateMaerskStatus(selectedRowKeys);
    if (res) onMaeskActionSuccess?.();
  };

  return (
    <Row className="ml-2" gutter={8}>
      {showQuoteBtn && (
        <Col span={quoteSpan ?? 10}>
          <ButtonComponent
            className="search-bar--trigger"
            text={quoteBtnText? quoteBtnText:"Send Quote"}
            loading={maerskQuoteLoading}
            onClick={handleSendQuote}
            disabled={disabled}         
          />
        </Col>
      )}

      {showUpdateStatus && (
        <Col span={statusSpan ?? 8}>
          <ButtonComponent
            className="search-bar--trigger"
            text="Update Status"
            loading={maerskStatusLoading}
            onClick={handleUpdateStatus}
          />
        </Col>
      )}
    </Row>
  );
};

export default MaerskActions;
